import { render, staticRenderFns } from "./wl-exclusions.vue?vue&type=template&id=2d8b5211&scoped=true"
import script from "./wl-exclusions.vue?vue&type=script&lang=js"
export * from "./wl-exclusions.vue?vue&type=script&lang=js"
import style0 from "./wl-exclusions.vue?vue&type=style&index=0&id=2d8b5211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b5211",
  null
  
)

export default component.exports